import { createContext } from 'react';
import { useFiltersContext } from '../../../../../Dashboards/Common/Filters/hooks/useFiltersContext';
import { useChartsData, QUERY_KEYS_SIA } from '../../../../Common/hooks/useChartsData';

export const ServicesChartsDataContext = createContext();

const ServicesChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SIA.PROCEDURES,
            url: 'governanceroom/dashboard/services/stratify/procedure'
        },
        {
            location: filters.unidade.value,
            year: filters.ano?.value,
            month: filters.competencia?.value,
        }
    );

    const chartData = data?.counterByProcedure
        ? {
              counterByProcedure: data.counterByProcedure || [],
              ranking:
                  [
                      ...data.counterByProcedure.slice(0, 10),
                      {
                          type: 'Outros',
                          services: data.counterByProcedure
                              .slice(5)
                              .reduce(
                                  (acc, curr) => acc + Number(curr.services),
                                  0
                              ),
                          description: 'Outros'
                      }
                  ] || []
          }
        : {
              counterByProcedure: [],
              ranking: []
          };

    return (
        <ServicesChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                module,
                data
            }}
        >
            {children}
        </ServicesChartsDataContext.Provider>
    );
};

export default ServicesChartsDataProvider;
